import { MutationTree } from 'vuex'

import { AuthState } from './types'
import { state as initialState } from './index'

export const mutations: MutationTree<AuthState> = {
  reset(state) {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key]
    })
  },
  resetRequest(state) {
    Object.keys(initialState).forEach(key => {
      if (key.indexOf('request') === 0 || key === 'error') {
        state[key] = initialState[key]
      }
    })
  },
  setAuthentication(state, payload: any) {
    state.requestLogin = false
    state.accessToken = payload.accessToken
    state.idToken = payload.idToken
  },
  setRequestLogin(state, payload: boolean) {
    state.error = null
    state.requestLogin = payload
  },
  setRequestGetUserInfo(state, payload: boolean) {
    state.error = null
    state.requestGetUserInfo = payload
  },
  setUserInfo(state, payload: any) {
    state.userInfo = payload
    state.requestGetUserInfo = false
  },
  setError(state, payload: any) {
    state.requestLogin = false
    state.requestGetUserInfo = false
    state.error = payload
  },
}
